import React, {useEffect, useState} from 'react';
import {hotelCategoryService} from "../../../../jwt/_services/hotel/hotelCategoryService";
import {getStateByPath} from "../../../../redux/selectors";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle, Spinner} from "reactstrap";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {
    ADD_STATE, REMOVE_STATE, setApp,
    setFilter,
    setForm,
    setItem, setLoading,
    setTableParams, setUdn, setUserIsAdmin,
    setViewMode
} from "../../../../redux/actions/generics/IndexedActions";
import {LIST} from "../../../../components/i18n/i18n";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {ModalFormContainer} from "../../../../components/confirmAlert/ModalFormContainer";
import HomeCategorySectionForm from "./_form";
import {history} from "../../../../jwt/_helpers";

const HomeCategorySection = (props) => {
    const path = props?.path + '/categories';
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {  app, udn, userIsAdmin } = parentComponentState?.data || {};
    //const {  udn } = parentComponentState?.data || null;
    const {  listDomainObjects } = componentState?.data || [];
    const {  filter, loading } = componentState?.data || {};

    const [categorizedItems, setCategorizedItems] = useState([]);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect( () => {
        if( !app?.id || !udn?.id || filter)
            return

        props.setApp(path, app);
        props.setUdn(path, udn);
        props.setUserIsAdmin(path, userIsAdmin);

        props.setFilter(path , {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                udn : { id : udn.id },
                showInHome : true
            }
        });
    }, [ app, udn ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, hotelCategoryService, 0, 100, filter)
    }, [ filter ]);

    useEffect(() => {
        if (!listDomainObjects)
            return

        mapItemsToCategoryItems(listDomainObjects);
    }, [listDomainObjects]);

    const mapItemsToCategoryItems = (_listItems) => {
        const groupedItems = [];

        for (const item of _listItems) {
            const category = groupedItems.find(c => c.id === item.category);

            if (!category) {
                groupedItems.push({
                    id: item.category,
                    name: item.categoryName,
                    isOpen: true,
                    items: [item],
                });
            } else {
                category.items.push(item);
            }
        }

        groupedItems.map(group => group.items.sort((a, b) => a.priority - b.priority));

        setCategorizedItems( groupedItems );
    };

    // const onExpandContract = (index) => {
    //     let updatedCategorizedItems = [...categorizedItems];
    //     updatedCategorizedItems[index].isOpen = !updatedCategorizedItems[index].isOpen;
    //     setCategorizedItems(updatedCategorizedItems);
    // }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( HomeCategorySectionForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);
        ModalFormContainer(HomeCategorySectionForm, { path, data, Form: HomeCategorySectionForm });
    }

    const navigateTo = (data) => {
        if (data?.navigationUrl) {


            history.push(data?.navigationUrl);
        }

        // console.log(data);
        // switch (data?.code) {
        //     case 'REST':
        //         history.push("/main/core/restaurants");
        //         break;
        //     case 'XPA':
        //         history.push("/main/hotel/xpa");
        //         break;
        //     case 'XTORE_HXA':
        //         history.push("/main/hotel/xtore");
        //         break;
        //     case 'BUILDING':
        //         history.push("/main/hotel/houses");
        //         break;
        //     case 'ROOMS':
        //         history.push("/main/hotel/suites");
        //         break;
        //     default:
        //         break;
        // }
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        priority: reorderedItem.showOrder
                    })
                }

            }
        }

        console.log(dataRequest);
        genericIndexedActions.reorder(path, hotelCategoryService, dataRequest)
    }

    const renderCategoryItem = (item, index) => {
        return (
            <div id={'home-category-item'} key={'home-category-item-' + index} className={'home-category-item'}>
                <h3 className="code" onClick={_ => editItem(item)}>{(1 + index) + ' - ' + (item?.title || '')}</h3>
                <img className={'image' + (!item?.status ? ' grayscale' : '')}
                     src={item.mediaUrl}
                     alt={item?.title}
                     onClick={_ => editItem(item)}
                />
                <div className={'top-right-fixed'}>
                    <GenericButton
                        style={'table'}
                        toolTip={'Navegar a ' + item?.title}
                        icon={'fa-arrow-right'}
                        permission={'search'}
                        onClick={_ => navigateTo(item, index)}/>
                </div>
            </div>
        )
    }

    const setImageFile = (imageName) => {
        let img;

        try {
            img = require("../../../../assets/images/category/" + udn?.code?.toLowerCase() + "/" + imageName + ".jpg");
        } catch (_) {
            // img = require("../../../../assets/images/icon/parks/svg/gpoxc-icon.svg");
        }

        return img
    }

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            {
                loading ? <Spinner animation="border"/> :
                    categorizedItems.map((categoryGroup, index) => {
                    return (< >
                            {
                                categoryGroup?.items?.length > 0 &&
                                <DragDropList
                                    items={categoryGroup?.items?.sort((a, b) => a?.priority - b?.priority )}
                                    renderContent={renderCategoryItem}
                                    onReorder={onReorder}
                                    orientationHV={'ruby-text-container'} // CSS class para orientar los elementos horizontalmente
                                />
                            }
                        </>
                    )
                })
            }
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
    setApp,
    setUdn,
    setUserIsAdmin,
})
export default connect(mapStateToProps, mapActionsToProps)(HomeCategorySection)